import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateChallengeRequest } from './update-challenge-request';
import type { IUpdateChallengeResponse } from './update-challenge-response';
import { updateChallengeResponseSchema } from './update-challenge-response';

export async function updateChallengeApi({
  id,
  body,
}: IUpdateChallengeRequest): Promise<IValidatedResponse<IUpdateChallengeResponse>> {
  return putRequest<IUpdateChallengeResponse>({
    path: `/sys/challenges/${id}`,
    body,
    schema: updateChallengeResponseSchema,
  });
}
